// deserialize data from the "catch" block to be parsed
export var getParsedError = function (_a) {
    var error = _a.error, sagaName = _a.sagaName;
    try {
        var parsedErrorData = JSON.parse(error.message);
        return parsedErrorData;
    }
    catch (err) {
        console.error("catch the error in ".concat(sagaName), err);
        return err.message;
    }
};
